import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription, timer} from 'rxjs';
import { AutoLogoutService } from 'app/shared/services/auto-logout.service';

@Component({
  selector: 'autoLogoutWarningMsgBox',
  templateUrl: './autoLogoutWarningMsgBox.component.html',
  styleUrls: ['./autoLogoutWarningMsgBox.component.scss'],
})
export class AutoLogoutWarningMsgBoxComponent implements OnInit, OnDestroy {
  public timeLeft = 90;
  onTimeLeftChanged: Subscription;
  private logoutWarning: Subscription;

  constructor(
    public dialogRef: MatDialogRef<AutoLogoutWarningMsgBoxComponent>,
    public autoLogoutService: AutoLogoutService,
    @Inject(MAT_DIALOG_DATA) public secondsBeforeLogout: number,    
  ) {    
    this.dialogRef.disableClose = true; 
    this.timeLeft = secondsBeforeLogout;
  }

  ngOnInit() {    
    this.onTimeLeftChanged = timer(1000, 1000).subscribe( () => {
      if (this.timeLeft > 0)
      {        
        this.timeLeft = this.timeLeft - 1;
      }
      else
      {
        console.log('Auto logout time reached - User not active. Starting Logout');
        this.autoLogoutService.autoLogoutTriggered.next(true);
      }
    });
  
    // Close dialog if we get a event where showAutoLogoutWarningDlg.next = 0.
    this.logoutWarning = this.autoLogoutService.showAutoLogoutWarningDlg.subscribe((secondsBeforeLogout: number) => {      
      if (secondsBeforeLogout === 0)
      {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy() {
    if (this.onTimeLeftChanged) this.onTimeLeftChanged.unsubscribe();
    if (this.logoutWarning) this.logoutWarning.unsubscribe();
  }
}
